<template>
  <b-card no-body>
    <b-card-header>
      <i class="fa fa-magnet" /> Magneet
      <b-checkbox 
        v-model="mod.active" 
        switch 
        class="pull-right"
      >
        Actief
      </b-checkbox>
    </b-card-header>
    <b-card-body>
      <b-form-group 
        label="Jaar" 
        label-cols="8"
      >
        <b-input v-model="mod.jaar" />
      </b-form-group>

      <b-form-group 
        label="Start" 
        label-cols="8"
      >
        <b-input v-model="mod.start" />
      </b-form-group>

      <b-form-group 
        label="Eind" 
        label-cols="8"
      >
        <b-input v-model="mod.eind" />
      </b-form-group>
      Alles van {{ startjaar(mod) }} t/m {{ eindjaar(mod) }} gaat naar 
      {{ mod.jaar }}
    </b-card-body>
    <b-card-footer />
  </b-card>
</template>
<script>
import { magnetMixin } from "@/mixins/magnetMixin";
export default {
  name: "ModeratorMagnet",
  mixins: [
    magnetMixin
  ],
  props: {
    mod: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
};
</script>